export const locales = ['en'] as const;
export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = 'en';

export const localeNames: Record<Locale, string> = {
  en: 'English',
};

export const localeFlags: Record<Locale, string> = {
  en: 'GB',
};

// Currency settings per locale
export const localeCurrencies: Record<Locale, string> = {
  en: 'EUR',
};

// Date format per locale
export const localeDateFormats: Record<Locale, string> = {
  en: 'MM/dd/yyyy',
};
